const config = {
    APP_HOST: process.env.REACT_APP_HOST,
    WEBCHAT_HOST: process.env.REACT_APP_WEBCHAT_HOST,
    BACKEND_HOST: process.env.REACT_APP_BACKEND_HOST,
    BOT_SERVICE_HOST: process.env.REACT_APP_BOT_SERVICE_HOST,
    AUTH_HOST: process.env.REACT_APP_AUTH_HOST,
    WEBBACK_HOST: process.env.REACT_APP_WEBBACK_HOST,
    GRAPH_HOST: process.env.REACT_APP_GRAPH_HOST,
    FILE_UPLOAD_HOST: process.env.REACT_APP_FILE_UPLOAD_HOST,
    WEBCHAT_COMPANY_ID: process.env.REACT_APP_WEBCHAT_COMPANY_ID,
    WEBCHAT_VERSION: '1.7.4',
    jwtAuthToken: 'jwt-access-token',
    conversationStatuses: {
        botProcessing: 'BOT_PROCESSING',
        botClosed: 'BOT_CLOSED',
        unManaged: 'UN_MANAGED',
        operatorProcessing: 'OPERATOR_PROCESSING',
        operatorClosed: 'OPERATOR_CLOSED',
        userClosed: 'USER_CLOSED',
        gatheringQuestion: 'GATHERING_QUESTIONS'
    },
    conversationStatusesList: [
        'BOT_PROCESSING',
        'BOT_CLOSED',
        'UN_MANAGED',
        'OPERATOR_PROCESSING',
        'OPERATOR_CLOSED',
        'USER_CLOSED',
        'GATHERING_QUESTIONS'
    ],
    visaFirstSymbol: '4',
    notificationLevels: {
        success: 'success',
        error: 'error',
        warning: 'warning',
        info: 'info',
    },
    permissions: {
        management: 'management',
        billing: 'billing',
        chat: 'chat',
        any: 'any',
    },
    features: {
        // any
        ANY: 'ANY',

        // basics
        HOTKEYS: 'HOTKEYS',
        BILLING: 'BILLING',
        WEBCHAT_TRIGGER: 'WEBCHAT_TRIGGER',
        FILE_SHARING: 'FILE_SHARING',
        CONVERSATION_FORWARD: 'CONVERSATION_FORWARD',
        STATISTICS: 'STATISTICS',
        USER_MANAGEMENT: 'USER_MANAGEMENT',
        EXPIRATION_TIME: 'EXPIRATION_TIME',
        TEXT_ACTION_NO_AI: 'TEXT_ACTION_NO_AI',
        HARDCODED_MESSAGES: 'HARDCODED_MESSAGES',
        BLACK_LIST: 'BLACK_LIST',
        CATEGORIES: 'CATEGORIES',
        TEMPLATES: 'TEMPLATES',
        MESSAGE_EDIT: 'MESSAGE_EDIT',
        MESSAGE_DELETE: 'MESSAGE_DELETE',
        MESSAGE_REPLY: 'MESSAGE_REPLY',
        SKILLS: 'SKILLS',
        HISTORY: 'HISTORY',
        CONVERSATION_VISIBILITY: 'CONVERSATION_VISIBILITY',
        END_UNMANAGED_CHATS: 'END_UNMANAGED_CHATS',
        USER_INACTIVITY_ACTION: 'USER_INACTIVITY_ACTION',
        OPERATOR_INACTIVITY_ACTION: 'OPERATOR_INACTIVITY_ACTION',

        // in tariffs
        INTERNAL_CHATS: 'INTERNAL_CHATS',
        MY_HISTORY: 'MY_HISTORY',
        OPERATOR_CONNECT_LOGIC: 'OPERATOR_CONNECT_LOGIC',
        REMINDERS_NO_AI: 'REMINDERS_NO_AI',
        TICKETS: 'TICKETS',
        CUSTOMIZE_WEBCHAT: 'CUSTOMIZE_WEBCHAT',
        CUSTOMIZE_WEBCHAT_COLORS: 'CUSTOMIZE_WEBCHAT_COLORS',
        FORBIDDEN_WORDS: 'FORBIDDEN_WORDS',
        WORKING_HOURS: 'WORKING_HOURS',
        INITIAL_MESSAGES: 'INITIAL_MESSAGES',
        TYPING_MESSAGES_FOR_OPERATOR: "TYPING_MESSAGES_FOR_OPERATOR",
        AI: 'AI',
        TEAM_AI: 'TEAM_AI',
        GPT_AI: 'GPT_AI',
        WEBHOOKS: 'WEBHOOKS'
    },
    webhookTypes: {
        connectToOperator: "CONNECT_TO_OPERATOR",
    },
    rolesMap: {
        owner: 'ROLE_OWNER',
        admin: 'ROLE_ADMIN',
        agent: 'ROLE_AGENT',
    },
    messagesPageDefaultSize: 300,

    // modal
    closeTimeoutMS: 150,
    modalBackgroundColor: 'rgb(0 0 0 / 47%)',
    //
    locales: [
        {
            id: 'en',
            name: 'English',
            title: 'English',
            value: 'ENGLISH'
        },
        {
            id: 'hy',
            name: 'Armenian',
            title: 'Armenian',
            value: 'ARMENIAN'
        }
    ],
    locales2: [
        {
            id: 'en',
            name: 'en',
            title: 'en',
            value: 'en'
        },
        {
            id: 'hy',
            name: 'hy',
            title: 'hy',
            value: 'hy'
        }
    ],
    roles: [
        {
            id: 'ROLE_ADMIN',
            name: 'ADMIN',
            title: 'Admin',
            value: 'ROLE_ADMIN',
        },
        {
            id: 'ROLE_OWNER',
            name: 'OWNER',
            title: 'Owner',
            value: 'ROLE_OWNER',
        },
        {
            id: 'ROLE_AGENT',
            name: 'AGENT',
            title: 'Agent',
            value: 'ROLE_AGENT',
        },
    ],
    companyStatusMap: {
        active: 'ACTIVE',
        deleted: 'DELETED',
    },
    tariffStatusMap: {
        active: 'ACTIVE',
        trial: 'TRIAL',
        paymentRequired: 'PAYMENT_REQUIRED'
    },
    statusMap: {
        deleted: 'DELETED',
        pending: 'PENDING',
        disabled: 'DISABLED',
        enabled: 'ENABLED',
    },
    currentStatusMap: {
        available: 'AVAILABLE',
        pause: 'PAUSE',
        notHere: 'NOT_HERE',
        offline: 'OFFLINE',
    },
    statuses: [
        {
            id: 'PENDING',
            name: 'PENDING',
            value: 'PENDING',
            title: 'Pending',
        },
        {
            id: 'ENABLED',
            name: 'ENABLED',
            value: 'ENABLED',
            title: 'Enabled',
        },
        {
            id: 'DISABLED',
            name: 'DISABLED',
            value: 'DISABLED',
            title: 'Disabled',
        },
        {
            id: 'DELETED',
            name: 'DELETED',
            value: 'DELETED',
            title: 'Deleted',
            hide: true,
        },
    ],
    currentStatuses: [
        {
            id: 'AVAILABLE',
            name: 'AVAILABLE',
            value: 'AVAILABLE',
            title: 'Available',
        },
        {
            id: 'PAUSE',
            name: 'PAUSE',
            value: 'PAUSE',
            title: 'Pause',
        },
        {
            id: 'NOT_HERE',
            name: 'NOT_HERE',
            value: 'NOT_HERE',
            title: 'Not here',
        },
        {
            id: 'OFFLINE',
            name: 'OFFLINE',
            value: 'OFFLINE',
            title: 'Offline',
        },
    ],
    contactsNameSpaces: {
        incomings: 'incomings',
        conversations: 'conversations',
        members: 'members',
    },
    platforms: {
        company: 'COMPANY',
        operator: 'DESK',
    },
    messageTypes: {
        text: 'TEXT',
        photo: 'PHOTO',
    },
    AITypes: {
        GPT_AI: 'GPT_AI',
        TEAM_AI: 'TEAM_AI'
    },
    platformsMap: {
        company: 'COMPANY',
        webchat: 'WEBCHAT',
        messenger: 'MESSENGER',
        webex: 'WEBEX',
        telegram: 'TELEGRAM',
        instagram: "INSTAGRAM",
        whatsapp: 'WHATSAPP'
    },
    visitorsMap: {
        visitor: 'VISITOR',
        user: 'USER'
    },
    companyTypeMap: {
        scenario: 'SCENARIO',
        smart: 'SMART',
        parent: 'PARENT'
    },
    memberTabs: {
        connected: 'connected',
        notConnected: 'notConnectedMembers',
        invite: 'inviteNewMembers',
    },
    botPlatforms: {
        messenger: {
            appId: process.env.REACT_APP_MESSENGER_APP_ID,
        },
    },
    localeValues: {
        english: 'en',
        armenian: 'hy',
    },
    planValues: {
        current: 'current',
        future: 'future',
    },
    defaultLocaleOption: {
        value: 'en',
        label: 'En',
    },
    hardCodedMessagesTypesMap: {
        chatWithOperatorText: 'CHAT_WITH_OPERATOR_TEXT',
        chooseSkillText: 'CHOOSE_SKILL_TEXT',
        blockedText: 'BLOCKED_TEXT',
        aiErrorText: 'AI_ERROR_TEXT',
        aiWelcomeText: 'AI_WELCOME_TEXT',
        reminderText: 'REMINDER_TEXT',
        aiAttachmentAnswerText: 'AI_ATTACHMENT_ANSWER_TEXT',
        outWorkingHoursText: 'OUT_WORKING_HOURS_TEXT',
        returnBotButton: 'RETURN_BOT_BUTTON',
        reminderButton: 'REMINDER_BUTTON',
        endConversationText: 'END_CONVERSATION_TEXT',
        rateOperatorText: 'RATE_OPERATOR_TEXT',
        rateAIText: 'RATE_AI_TEXT',
        chooseFollowingText: 'CHOOSE_FOLLOWING_TEXT',
        sessionExpireText: 'SESSION_EXPIRE_TEXT',
        start: 'START',
        chatWithOperator: 'CHAT_WITH_OPERATOR',
        endConversation: 'END_CONVERSATION',
        goodButton: 'GOOD',
        badButton: 'BAD',
        dontKnowText: 'DONT_KNOW_TEXT',
        operatorJoinedText: 'OPERATOR_JOINED_TEXT'
    },
};


config.localesOptions = [
    {
        value: config.localeValues.english,
        label: 'English',
        title: 'EN',
    },
    {
        value: config.localeValues.armenian,
        label: 'Armenian',
        title: 'HY',
    },
];
config.planOptions = [
    {
        value: config.planValues.current,
        label: 'Current Plan',
        title: 'Current Plan',
    },
    {
        value: config.planValues.future,
        label: 'Future Plan',
        title: 'Future Plan',
    },
];

config.hardCodedMessagesTypes = Object.values(config.hardCodedMessagesTypesMap);

config.hardCodedMessagesTypeButtons = [
    config.hardCodedMessagesTypesMap.chatWithOperator,
    config.hardCodedMessagesTypesMap.start,
    config.hardCodedMessagesTypesMap.endConversation,
    config.hardCodedMessagesTypesMap.goodButton,
    config.hardCodedMessagesTypesMap.badButton,
    config.hardCodedMessagesTypesMap.returnBotButton,
    config.hardCodedMessagesTypesMap.reminderButton,
];


export default config;



// WEBPACK FOOTER //
// ./src/config.js